import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function PrincipalDeskPage() {
  return <PublicPage slug="principal-desk" />;
}
